document.addEventListener('DOMContentLoaded', function () {
  let buttons = document.querySelectorAll(
    '.pricing__item .pricing__item__top--expandable'
  );

  buttons.forEach((button) => {
    button.addEventListener('click', function (event) {
      let parentPricingItem = event.currentTarget.closest('.pricing__item');
      if (parentPricingItem) {
        let content = parentPricingItem.querySelector(
          '.pricing__item__content'
        );
        if (content) {
          content.classList.toggle('active');
        }
        button.classList.toggle('active');
      }
    });
  });

  document
    .getElementById('pricing-form')
    .addEventListener('submit', function (event) {
      event.preventDefault();

      const formData = new FormData();
      formData.append('name', document.getElementById('name').value);
      formData.append('email', document.getElementById('email').value);
      formData.append('tel', document.getElementById('phone').value);
      formData.append(
        'message',
        document.getElementById('membershipType').value
      );

      fetch('https://email-service-glxivwm5yq-nw.a.run.app', {
        method: 'POST',
        body: formData,
      })
        .then((data) => {
          const pricingForm = document.getElementById('pricing-form');
          const formSuccess = document.getElementById('form-success');

          if (pricingForm) {
            pricingForm.style.display = 'none';
          }

          if (formSuccess) {
            formSuccess.style.display = 'block';
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
});

const handleSelect = () => {
  document.querySelectorAll('.dropdown').forEach(function (dropdownWrapper) {
    const dropdownBtn = dropdownWrapper.querySelector('.dropdown__button');
    const dropdownList = dropdownWrapper.querySelector('.dropdown__list');
    const dropdownItems = dropdownList.querySelectorAll('.dropdown__list-item');
    const dropdownInput = dropdownWrapper.querySelector(
      '.dropdown__input_hidden'
    );

    dropdownBtn.addEventListener('click', function () {
      dropdownList.classList.toggle('dropdown__list_visible');
      this.classList.toggle('dropdown__button_active');
    });

    dropdownItems.forEach(function (listItem) {
      listItem.addEventListener('click', function (e) {
        dropdownItems.forEach(function (el) {
          el.classList.remove('dropdown__list-item_active');
        });
        e.target.classList.add('dropdown__list-item_active');
        dropdownBtn.innerText = this.innerText;
        dropdownInput.value = this.dataset.value;
        dropdownList.classList.remove('dropdown__list_visible');
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target !== dropdownBtn) {
        dropdownBtn.classList.remove('dropdown__button_active');
        dropdownList.classList.remove('dropdown__list_visible');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' || e.key === 'Escape') {
        dropdownBtn.classList.remove('dropdown__button_active');
        dropdownList.classList.remove('dropdown__list_visible');
      }
    });
  });
};

handleSelect();
